<template>
  <div class="retags">
    <div class="retags-container" v-if="items.title && items.description">
      <div class="reetag-title">{{ items.title }}</div>
      <div class="reetag-desc" v-htmlsafe="items.description"></div>
    </div>
    <div class="reetags-player" :class="items.cssClass">
      <iframe
        class="reetags__iframe"
        name="player"
        title="reetag"
        :src="iframeUrl"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture; web-share"
        loading="lazy"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'reetag',
  data() {
    return {
      iframeUrl: null,
    };
  },
  props: {
    items: {
      type: Object,
      required: true,
      default: null,
    },
  },
  mounted() {
    this.loadScript();
    this.iframeUrl =
      'https://player.reetags.com/player?token=' + this.items.token;
  },
  methods: {
    loadScript() {
      let scriptEle = document.createElement('script');
      scriptEle.setAttribute('type', 'application/javascript');
      scriptEle.setAttribute('src', this.items.scriptSrc);
      document.head.appendChild(scriptEle);
    },
  },
};
</script>
<style scoped lang="scss" src="./reetag.scss"></style>
